import React, { useEffect, useRef, useState } from 'react'
import { ErrorModal, SuccessModal, WarningModal } from '../../components/Modal'
import Progressbar from '../../components/Progress'
import { useNavigate } from 'react-router-dom'
import Layout from '../../components/Layout'
import Button from '../../components/Button'
import RecoveryStyle from './RecoveryStyle'
import { useSelector } from 'react-redux'
import { get } from 'lodash'
import api, { customFuncsApi } from '../../api'
import moment from 'moment'
import ClipLoader from 'react-spinners/ClipLoader'
import customMainApi from '../../api'
import dayjs from 'dayjs'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import { DatePicker, Button as AntButton, Empty, Tag } from 'antd'
import { useTranslation } from 'react-i18next'
import useEnterKey from '../../hooks/useEnterKey'
import { formatNumber } from '../../utils/formatNumber'
import RenderTableHeader from '../../components/TableHeader'
import RenderTableRow from '../../components/TableRow'
import { checkValueToNotNull } from '../../utils/checkValue'
import { debouncedSet } from '../../utils/debounce'

const { RangePicker } = DatePicker

const Recovery = () => {
	const { t } = useTranslation()

	dayjs.extend(advancedFormat)
	dayjs.extend(customParseFormat)
	const { getMe } = useSelector((state) => state.main)

	const navigate = useNavigate()

	const startOfMonth = dayjs().startOf('month')
	const endOfMonth = dayjs().endOf('month')
	const startDateFormatted = startOfMonth.format('YYYY-MM-DD')
	const endDateFormatted = endOfMonth.format('YYYY-MM-DD')
	const dateFormat = 'YYYY-MM-DD'

	const errorRef = useRef()
	const successRef = useRef()
	const warningRef = useRef()

	const [isLoading, setIsLoading] = useState(false)
	const [isProtsent, setIsProtsent] = useState(false)

	const [status] = useState('open')
	const [clientName, setClientName] = useState('')
	const [imei, setIMEI] = useState('')
	const [userCardCode, setUserCardCode] = useState('')
	const [numberProtsent, setnumberProtsent] = useState(1)
	const [dateStart, setDateStart] = useState(
		dayjs('2010-01-01').format(dateFormat),
	)

	const [sortConfig, setSortConfig] = useState({
		column: null,
		direction: null,
	})

	const [dateEnd, setDateEnd] = useState(dayjs().format(dateFormat))
	const [promisedDate, setPromisedDate] = useState('')

	const [executer, setExecuter] = useState([])
	const [customerData, setCustomerData] = useState([])
	const [doceAndInsData, setDoceAndInsData] = useState([])
	const [progress, setProgress] = useState(0)
	const [data, setData] = useState({
		data: [],
	})
	const [currentPage, setCurrentPage] = useState(0)
	const [businessLoading, setBusinessLoading] = useState(false)
	const [employeeID, setEmployeeID] = useState('')
	const [executorLoading, setExecutorLoading] = useState(false)
	const [maxPage, setMaxPage] = useState(20)
	const [userFields, setUserFields] = useState([])
	const [page, setPage] = useState(0)
	const [phoneNum, setPhoneNum] = useState('')

	useEffect(() => {
		getAllGetterMoney()
		doceAndIns()
		userFieldsFn()
	}, [])

	const userFieldsFn = () => {
		customMainApi
			.get('UserFieldsMD', {
				params: {
					$filter: "TableName eq 'OINV'",
					$select: 'Name,ValidValuesMD,TableName',
				},
			})
			.then((res) => {
				setUserFields(JSON.parse(res.data).value)
			})
	}

	const getAllGetterMoney = () => {
		api
			.get(
				`$crossjoin(EmployeesInfo, Departments)?$filter=Departments/Name eq 'Undiruv' and EmployeesInfo/Department eq Departments/Code&$expand=EmployeesInfo($select=EmployeeID,LastName,FirstName,U_CashAccount,U_CardAccount,U_TransAccount),Departments($select=Name,Code)`,
				{
					headers: {
						Prefer: 'odata.maxpagesize=90000',
					},
				},
			)
			.then((res) => {
				const resData = get(JSON.parse(res.data), 'value', [])
				setExecuter(resData)
			})
			.catch((err) => {
				errorRef.current?.open(
					get(JSON.parse(err.response.data), 'error.message', ''),
				)
			})
	}

	const doceAndIns = () => {
		api
			.get(
				`SQLQueries('latePaymentsMin')/List?date1='${startDateFormatted}T00:00:00Z'&date2='${endDateFormatted}T00:00:00Z'`,
				{
					headers: {
						Prefer: 'odata.maxpagesize=90000',
					},
				},
			)
			.then((res) => {
				const resData = get(JSON.parse(res.data), 'value', [])
				setDoceAndInsData(resData)
			})
			.catch((err) => {
				console.log(JSON.parse(err.response.data), 'error.message', '')

				// errorRef.current?.open(
				// 	get(JSON.parse(err.response.data), 'error.message', ''),
				// )
			})
	}

	const recovery = (
		startD,
		endD,
		promisedD = '',
		userCardCode = clientName.includes(',')
			? clientName.split(' , ')[1]
			: clientName,
		phoneNum,
	) => {
		setIsLoading(true)
		const sort = `${sortConfig.direction !== null ? `&orderBy=[{"name": "${sortConfig.column}", "type" : "${sortConfig.direction}"}]` : ``}`
		customFuncsApi
			.get(
				`installments?date1='${startD === '' ? '2012-01-01' : startD}T00:00:00Z'&date2='${endD === '' ? moment().format('YYYY-MM-DD') : endD}T00:00:00Z&U_PromisedDate='${promisedD === '' ? '' : promisedD + 'T00:00:00Z'}'${clientName.split(' , ')[1] ? `&CardCode='${clientName.split(' , ')[1]}'` : ''}${
					get(getMe, 'Department2.Name', '') === 'Boshqaruv' ||
					get(getMe, 'Department2.Name', '') === 'Undiruvchi1'
						? ''
						: `&U_Employee=${get(getMe, 'EmployeeID', '')}`
				}${status?.length <= 0 ? '' : `&status=${status}`}&$skip=${page * 10}${imei !== '' ? `&IntrSerial='${imei}'` : ''}${sort}&U_Telephone=${checkValueToNotNull(phoneNum)}`,

				{
					params: {
						U_Employee: employeeID?.length <= 0 ? undefined : employeeID,
					},
					headers: {
						Prefer: `odata.maxpagesize=${maxPage}`,
					},
				},
			)
			.then((res) => {
				if (get(res, 'status', 0) === 401) navigate('/login', { replace: true })
				const resData = get(res, 'data.value', [])
				setData({ data: resData })

				setData({
					data: [...resData],
				})
				setIsLoading(false)
			})
			.catch((err) => {
				errorRef.current?.open(
					get(JSON.parse(err.response.data), 'error.message', ''),
				)
				if (get(err, 'response.status', 0) === 401)
					navigate('/login', { replace: true })

				setIsLoading(false)
			})
	}

	const handleSort = (column) => {
		let direction = 'ASC'
		if (sortConfig.column === column && sortConfig.direction === 'ASC') {
			direction = 'DESC'
		} else if (
			sortConfig.column === column &&
			sortConfig.direction === 'DESC'
		) {
			direction = null
		}
		setSortConfig({ column, direction })
	}

	useEffect(() => {
		recovery(dateStart, dateEnd)
	}, [page, maxPage, sortConfig, sortConfig])

	const AddExecutorsForInstallments = async () => {
		setExecutorLoading(true)
		setIsProtsent(true)
		try {
			const installments = await customFuncsApi
				.get(`installments?U_Employee=null`, {
					headers: {
						Prefer: 'odata.maxpagesize=1000000',
					},
				})
				.then((res) => res.data.value)

			const chunkSize = 100
			const totalInstallments = installments?.length

			const sendChunk = async (chunk) => {
				const chunkData = {
					invoices: chunk.map((v) => ({
						DocEntry: v.DocEntry,
						InstallmentId: v.InstlmntID,
					})),
					dunners: executer.map((v) => v.EmployeesInfo.EmployeeID),
				}
				await customFuncsApi.post('assignDunners', chunkData)
			}

			for (let i = 0; i < totalInstallments; i += chunkSize) {
				const chunk = installments.slice(i, i + chunkSize)
				await sendChunk(chunk)
				let protsent = Math.floor((i / totalInstallments) * 100)
				setProgress(protsent)
			}
		} catch (error) {
			console.error('Error processing installments in Recovery:', error)
		} finally {
			setExecutorLoading(false)
			setIsProtsent(false)
		}
	}

	const newDatas = () => {
		if ((data.data.length = maxPage)) {
			setPage((prevState) => prevState + Number(String(maxPage)[0]))
			setCurrentPage((prevState) => prevState + 1)
		} else {
			alert(t('noOtherInfo'))
		}
	}

	const oldData = () => {
		if (page === 0) {
			alert(t('noOtherInfo'))
		} else {
			setPage((prevState) => prevState - Number(String(maxPage)[0]))
			setCurrentPage((prevState) => prevState - 1)
		}
	}

	const viewItem = (v) => {
		const queryParams = new URLSearchParams({
			DocEntry: JSON.stringify(v.DocEntry),
			InstlmntID: JSON.stringify(v.InstlmntID),
		}).toString()
		window.open(`/viewRecoveryItem?${queryParams}`, '_blank')
	}

	const searchUser = (a = '') => {
		setClientName(a)
		setBusinessLoading(true)
		const formattedName = a.includes("'") ? a.replace(/'/g, "''") : a

		api
			.get(
				`BusinessPartners?$select=CardCode,CardName,Address,Phone1,GroupCode&$filter=CardType eq 'cCustomer' and Frozen eq 'tNO' and (contains(CardName, '${formattedName}') or contains(U_Telephone, '${formattedName}') or contains(CardCode, '${formattedName}'))`,
			)
			.then((res) => {
				const resData = get(JSON.parse(res.data), 'value', [])
				if (
					!(resData.length === 1) ||
					!a.includes(resData[0].CardName) ||
					!a.includes(resData[0].CardCode)
				)
					setCustomerData(resData)
				if (
					resData.length === 0 &&
					(!a.includes(resData[0].CardName) || !a.includes(resData[0].CardCode))
				) {
					setCustomerData([{ CardName: 'Нет данных', CardCode: '' }])
				}
			})
			.catch((err) => {
				// errorRef.current?.open(
				//   get(JSON.parse(err.response.data), 'error.message', ''),
				// )
			})
			.finally(() => {
				setBusinessLoading(false)
			})
	}

	useEffect(() => {
		const delay = 1000
		let timeoutId
		if (clientName) {
			timeoutId = setTimeout(() => {
				searchUser(clientName)
			}, delay)
		}
		return () => {
			clearTimeout(timeoutId)
		}
	}, [clientName])

	const handleChange = (e) => {
		const newSearchTerm = e.target.value
		if (e.target.value?.includes(' , ')) {
			setUserCardCode(e.target.value?.split(' , ')[1])
		} else {
			setUserCardCode('')
		}
		setClientName(newSearchTerm)
	}

	const distribution = () => {
		distributionMain(0, 50, 1)
		setIsProtsent(true)
	}

	const distributionMain = (currentN, nextN, someN) => {
		const dunners = executer.map((v) => {
			return get(v, 'EmployeesInfo.EmployeeID', 0)
		})
		setProgress(0)
		let someData = doceAndInsData.slice(currentN, nextN).map((v, i) => {
			return {
				DocEntry: v.DocEntry,
				InstallmentId: v.InstlmntID,
			}
		})

		customFuncsApi
			.post(
				`assignDunners`,
				{
					invoices: someData,
					dunners,
					Origin: window.origin,
				},
				{
					timeout: 1000 * 60,
					onUploadProgress: (progressEvent) => {
						const { loaded, total } = progressEvent
						let percent = Math.floor((loaded / total) * 100)
						setProgress(+percent)
					},
				},
			)
			.then(() => {
				if (Math.floor(doceAndInsData.length / 50) + 1 > someN) {
					distributionMain(currentN + 50, nextN + 50, someN + 1)
					setnumberProtsent(someN + 1)
				} else {
					alert("Amaliyot to'liq yuklandi")
					setIsProtsent(false)
				}
			})
			.catch((err) => {
				errorRef.current?.open(get(err, 'message', ''))
				setIsProtsent(false)
			})
	}

	const onRangeChange = (dates, dateStrings) => {
		if (dates) {
			const start = dates[0]
			const end = dates[1]

			setDateStart(start ? start.format('YYYY-MM-DD') : null)
			setDateEnd(end ? end.format('YYYY-MM-DD') : null)
		} else {
			console.log('Clear')
		}
	}

	const handlePhoneChange = (val) => {
		debouncedSet(val, setPhoneNum)
	}

	const switchProblemStatus = (val, cardCode) => {
		switch (val) {
			case 'Normal':
				return <Tag color="green">{cardCode}</Tag>
			case 'Problem - Abduvahob':
				return <Tag color="magenta">{cardCode}</Tag>
			case 'Problem1 - Murod':
				return <Tag color="red">{cardCode}</Tag>
			case 'Problem2 - Abdulloh':
				return <Tag color="purple">{cardCode}</Tag>
			case 'Problem3 - Farrux':
				return <Tag color="geekblue">{cardCode}</Tag>
			case 'Militsiya':
				return <Tag color="black">{cardCode}</Tag>
			default:
				return <Tag>{cardCode}</Tag>
		}
	}

	useEnterKey(() =>
		recovery(dateStart, dateEnd, promisedDate, userCardCode, phoneNum),
	)

	return (
		<Layout>
			<RecoveryStyle>
				<div className="container minWidthContainer">
					<div style={{ width: '100%' }}>
						<p className="topTitle mb-8">{t('recoverySchedulel')}</p>
						<div className="flex flex-col sm:flex-row  items-end gap-5 mt-10 w-full">
							<div className="relative w-full">
								<p className={'font-medium text-zinc-600 text-sm mb-1'}>
									{t('client')}
								</p>
								<input
									className={
										'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full  '
									}
									type="text"
									value={clientName}
									onChange={(e) => {
										handleChange(e)
									}}
								/>
								{clientName && (
									<div className="absolute top-15 left-0 bg-white w-full z-10 border-[1px] border-[#d9d9d9] max-h-[300px] overflow-y-scroll">
										{businessLoading ? (
											<ClipLoader size={10} />
										) : (
											customerData.map((v, i) => {
												return (
													<div
														key={i}
														className="p-2 border-b cursor-pointer hover:bg-gray-100"
														onClick={() => {
															if (v.CardName === 'Нет данных') return
															setUserCardCode(v.CardCode)
															setClientName(`${v.CardName} , ${v.CardCode}`)
															setCustomerData([])
														}}
													>
														{v.CardName} , {v.CardCode}
													</div>
												)
											})
										)}
									</div>
								)}
							</div>
							<div className="flex flex-col w-full">
								<p className={'font-medium text-zinc-600 text-sm mb-1'}>
									{t('imei')}
								</p>
								<input
									type="text"
									className={
										'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full  '
									}
									value={imei}
									onChange={(e) => {
										setIMEI(e.target.value)
									}}
								/>

								<datalist id="client">
									{customerData.map((v, i) => (
										<option
											key={i}
											value={`${get(v, 'CardName', '')} , ${get(
												v,
												'CardCode',
												'',
											)}`}
										/>
									))}
								</datalist>
							</div>
							<div className="flex flex-col w-full">
								<p className={'font-medium text-zinc-600 text-sm mb-1'}>
									{t('clientPhoneNumber')}
								</p>
								<input
									type="text"
									className={
										'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full  '
									}
									value={phoneNum}
									onChange={(e) => {
										setPhoneNum(e.target.value)
									}}
								/>
							</div>

							<div className="flex flex-col w-full">
								<p className={'font-medium text-zinc-600 text-sm mb-1'}>
									{t('date')}
								</p>
								<RangePicker
									value={[
										dateStart ? dayjs(dateStart, dateFormat) : null,
										dateEnd ? dayjs(dateEnd, dateFormat) : null,
									]}
									format={dateFormat}
									onChange={onRangeChange}
									className='border-[1px] border-[#DFE2E9"] p-2 rounded-md min-w-[240px] w-full '
								/>
							</div>
							<div className="flex flex-col w-full">
								<p className={'font-medium text-zinc-600 text-sm mb-1'}>
									{t('dateDeadline')}
								</p>
								<input
									type="date"
									className={
										'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full'
									}
									defaultValue={promisedDate}
									onChange={(v) => {
										setPromisedDate(v.target.value)
									}}
								/>
							</div>

							{(get(getMe, 'Department2.Name', '') === 'Undiruvchi1' ||
								get(getMe, 'Department2.Name', '') === 'Boshqaruv') && (
								<div className="flex flex-col ">
									<p className={'font-medium text-zinc-600 text-sm mb-1'}>
										{t('receiver')}
									</p>
									<select
										name="executer"
										id="executer"
										className={
											'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full sm:w-[150px]'
										}
										onChange={(v) => {
											setEmployeeID(v.target.value)
										}}
										value={employeeID}
									>
										<option></option>
										<option value="null">Без приёмщика</option>
										{executer.map((v, i) => {
											return (
												<option
													value={get(v, 'EmployeesInfo.EmployeeID', 0)}
													key={i}
													selected={
														v.EmployeesInfo.EmployeeID ===
														get(data, 'U_Employee', '')
													}
												>
													{get(v, 'EmployeesInfo.FirstName', 'Name')}{' '}
													{get(v, 'EmployeesInfo.LastName', 'Surename')}
												</option>
											)
										})}
									</select>
								</div>
							)}

							<AntButton
								loading={isLoading}
								className={'bg-[#0A4D68] text-white h-10 w-full sm:w-[100px]'}
								onClick={() =>
									recovery(
										dateStart,
										dateEnd,
										promisedDate,
										userCardCode,
										phoneNum,
									)
								}
							>
								{t('search')}
							</AntButton>
						</div>
						<div className="mt-8 mb-2 flex flex-col md:flex-row max-w-md">
							<div className="flex gap-2 items-center">
								<div className="size-6 rounded-full bg-red-200"></div>
								<span> {'<'} 30 день</span>
							</div>
							<div className="flex gap-2 items-center">
								<div className="size-6 rounded-full bg-red-400"></div>
								<span> {'<'} 60 день</span>
							</div>
							<div className="flex gap-2 items-center">
								<div className="size-6 rounded-full bg-black"></div>
								<span> {'>'} 60+ день</span>
							</div>
						</div>
						{isLoading ? (
							<ClipLoader
								loading={true}
								size={75}
								aria-label="Loading Spinner"
								className={'loader'}
								data-testid="loader"
							/>
						) : (
							<>
								<div className="overflow-y-auto">
									<table className="w-full text-sm text-left  text-gray-700 ">
										<thead className="text-xs text-gray-700 uppercase bg-gray-50 ">
											<tr>
												<RenderTableHeader title="status" />
												<RenderTableHeader title="clientCode" />
												<RenderTableHeader
													title="clientName"
													padding="px-14 py-4"
												/>
												<RenderTableHeader
													title="product"
													padding="px-14 py-4"
												/>
												<RenderTableHeader title="imei" padding="px-6 py-4" />
												<RenderTableHeader
													title="debtUntilToDate"
													sortColumn="DebtUntilToday"
													handleSort={handleSort}
													sortConfig={sortConfig}
													isSortable
												/>
												<RenderTableHeader
													title="monthlyPayment"
													sortColumn="InsTotal"
													handleSort={handleSort}
													sortConfig={sortConfig}
													isSortable
												/>
												<RenderTableHeader
													title="debtTotal"
													sortColumn="TotalDebt"
													handleSort={handleSort}
													sortConfig={sortConfig}
													isSortable
												/>
												<RenderTableHeader
													title="paidToDate"
													sortColumn="PaidToDate"
													handleSort={handleSort}
													sortConfig={sortConfig}
													isSortable
												/>
												<RenderTableHeader
													title="totalPrice"
													sortColumn="DocTotal"
													handleSort={handleSort}
													sortConfig={sortConfig}
													isSortable
												/>
												<RenderTableHeader
													title="dateOfSale"
													sortColumn="DueDate"
													handleSort={handleSort}
													sortConfig={sortConfig}
													isSortable
												/>
												{get(getMe, 'Department2.Name', '') ===
													'Undiruvchi1' && (
													<RenderTableHeader title="executor" />
												)}

												{/* <RenderTableHeader
													title="pageNumber"
													sortColumn="U_DaftarBet"
													handleSort={handleSort}
													sortConfig={sortConfig}
													isSortable
												/> */}
												<RenderTableHeader title="status" />

												<RenderTableHeader
													title="dateDeadline"
													sortColumn="U_PromisedDate"
													handleSort={handleSort}
													sortConfig={sortConfig}
													isSortable
												/>
												<RenderTableHeader title="lastComment" />
												<RenderTableHeader
													title="lastCommentDate"
													sortColumn="U_COMMENTS.U_CreateTime"
													handleSort={handleSort}
													sortConfig={sortConfig}
													isSortable
												/>
											</tr>
										</thead>
										<tbody>
											{data.data.length > 0 ? (
												data.data.map((v, i) => {
													return (
														<tr
															key={i}
															onClick={() => viewItem(v)}
															className="bg-white border-b  hover:bg-gray-50 "
														>
															{/* Bu ozi qogani yaxshi ekan */}
															<td className="px-6 py-4 font-medium ">
																<div
																	className={
																		v['INV6.PaidToDate'] ===
																		get(v, 'InsTotal', 0)
																			? // hover:border hover:border-zinc-400
																				'size-7 rounded-full bg-green-400 '
																			: moment().diff(v.DueDate, 'days') < 30
																				? 'size-7 rounded-full bg-red-200  '
																				: moment().diff(v.DueDate, 'days') < 60
																					? 'size-7 rounded-full bg-red-400 '
																					: 'size-7 rounded-full bg-black '
																	}
																></div>
															</td>
															<td className={'px-6 py-4  text-center'}>
																{switchProblemStatus(
																	get(v, 'U_PROBLEM.Name', ''),
																	get(v, 'CardCode', 'Код покупателя'),
																)}
															</td>
															{/* <RenderTableRow
																value={get(v, 'CardCode', 'Код покупателя')}
																className={'font-medium'}
															/> */}
															<RenderTableRow
																value={get(v, 'CardName', 'Имя покупателя')}
															/>
															<RenderTableRow
																value={`${checkValueToNotNull(get(v, 'Dscription', ''))} ${checkValueToNotNull(get(v, 'U_Color', ''))} ${checkValueToNotNull(get(v, 'U_Condition', ''))} ${checkValueToNotNull(get(v, 'U_Memory', ''))}`}
															/>
															<RenderTableRow
																value={get(v, 'IntrSerial', '')}
															/>
															<RenderTableRow
																value={`${formatNumber(get(v, 'DebtUntilToday', 0))} USD`}
															/>
															<RenderTableRow
																value={`${formatNumber(get(v, 'InsTotal', 0))} USD`}
															/>
															<RenderTableRow
																value={`${formatNumber(get(v, 'TotalDebt', 0))} USD`}
															/>
															<RenderTableRow
																value={`${formatNumber(get(v, 'PaidToDate', 0))} USD`}
															/>
															<RenderTableRow
																value={`${formatNumber(get(v, 'DocTotal', 0))} USD`}
															/>
															<RenderTableRow
																value={`${moment(get(v, 'DueDate', '')).format('DD.MM.YYYY')}`}
															/>
															{get(getMe, 'Department2.Name', '') ===
																'Undiruvchi1' && (
																<RenderTableRow
																	value={`${checkValueToNotNull(get(v, 'firstName', ''))} ${checkValueToNotNull(get(v, 'lastName', ''))}`}
																/>
															)}
															{/* <RenderTableRow
																value={get(v, 'U_DaftarBet', '')}
															/> */}
															<RenderTableRow
																value={get(v, 'U_PROBLEM.Name', '')}
															/>

															<RenderTableRow
																value={get(v, 'U_PromisedDate', '')}
															/>
															<RenderTableRow
																value={get(v, 'U_COMMENTS.U_Text', '')}
															/>
															<RenderTableRow
																value={
																	get(v, 'U_COMMENTS.U_CreateTime', '')
																		? moment(
																				get(v, 'U_COMMENTS.U_CreateTime', ''),
																			).format('YYYY-MM-DD HH:mm')
																		: ''
																}
															/>
														</tr>
													)
												})
											) : (
												<tr>
													<td colSpan="10">
														<Empty
															description={t('noInfo')}
															image={Empty.PRESENTED_IMAGE_SIMPLE}
														/>
													</td>
												</tr>
											)}
										</tbody>
									</table>
								</div>
								<div className="flex items-center justify-between flex-col sm:flex-row mb-5 mt-5 w-full gap-5">
									<div className="flex items-center w-full">
										<Button
											disabled={page === 0}
											className={'btn'}
											onClick={oldData}
										>
											{'<'}
										</Button>
										<p className={'mr-2'}>
											<p>{currentPage + 1}</p>
										</p>
										<Button
											disabled={data.data?.length < maxPage}
											className={'btn'}
											onClick={newDatas}
										>
											{'>'}
										</Button>
									</div>

									<div className="w-full  sm:w-[100px]">
										<select
											value={maxPage}
											className="w-full  sm:w-[100px] h-10   rounded-lg text-center border-2 border-gray-200"
											onChange={(e) => {
												setMaxPage(e.target.value)
												setPage(0)
												setCurrentPage(0)
											}}
										>
											<option value="10">10</option>
											<option value="20">20</option>
											<option value="30">30</option>
											<option value="50">50</option>
											<option value="80">80</option>
										</select>
									</div>
									<div className="w-full">
										{get(getMe, 'Department2.Name', '') !== 'Undiruv' &&
										doceAndInsData?.length > 1 ? (
											<AntButton
												className={
													'bg-[#0A4D68] text-white h-10 w-full rounded-lg sm:w-auto'
												}
												loading={executorLoading}
												onClick={AddExecutorsForInstallments}
											>
												{t('addNewDebtors')}
											</AntButton>
										) : null}
									</div>
									<div className="w-full">
										{get(getMe, 'Department2.Name', '') !== 'Undiruv' &&
										doceAndInsData?.length > 1 ? (
											<AntButton
												className={
													'bg-[#0A4D68] text-white h-10 w-full rounded-lg sm:w-auto'
												}
												onClick={distribution}
												loading={isLoading}
											>
												{t('distributeAllDebtors')}
											</AntButton>
										) : null}
									</div>
								</div>
							</>
						)}

						{isProtsent ? (
							<>
								<p className="progres">{t('waitProgress')} </p>

								<Progressbar bgcolor="green" progress={progress} height={23} />
							</>
						) : null}
					</div>
				</div>
			</RecoveryStyle>
			<>
				<ErrorModal getRef={(r) => (errorRef.current = r)} />
				<SuccessModal getRef={(r) => (successRef.current = r)} />
				<WarningModal getRef={(r) => (warningRef.current = r)} />
			</>
		</Layout>
	)
}

export default Recovery
